var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"privacy-page"},[_c('HeaderComponent',{attrs:{"name":_vm.content?.title}}),_vm._v(" "),_c('div',{staticClass:"privacy-page__content",domProps:{"innerHTML":_vm._s(_vm.content?.text)}}),_vm._v(" "),_c('FooterComponent'),_vm._v(" "),(_vm.isMobile)?_c('MobileBarComponent'):_vm._e(),_vm._v(" "),_c('PopupsSection')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }